import { CoreLaunchOptions } from "@amazon-connect/app-controller";

export type AppLaunchOptions = CoreLaunchOptions;
